import { Pipe, PipeTransform } from '@angular/core';
import { ShipmentType, TradeClass } from '@shared/service-proxies/service-proxies';

type TradeClassMap = { [key in keyof typeof TradeClass]: string };

const TRADE_CLASSES_MAP: TradeClassMap = {
  0: 'Import',
  1: 'Export',
  2: 'Domestic',
  'Unknown': 'Unknown',
  'Import': 'Import',
  'Export': 'Export',
  'Domestic': 'Domestic',
} as const;

export function listTradeClasses(): TradeClass[] {
  // Due to map containing mappings from number and from string
  // need to filter out numbers
  return Object.keys(TRADE_CLASSES_MAP).filter(x => Number.isNaN(Number(x))) as unknown as TradeClass[];
}

export function tradeClassToString(tradeClass: TradeClass) {
  return TRADE_CLASSES_MAP[tradeClass];
}

export function getTradeClassesForShipmentType(shipmentType: ShipmentType): TradeClass[] {
  switch (shipmentType) {
    case ShipmentType.Inbound:
      return [TradeClass.Import, TradeClass.Domestic];
      break;
    case ShipmentType.Outbound:
      return [TradeClass.Export, TradeClass.Domestic];
      break;
    default: {
      // Ensure no other type exists
      const exhaustiveCheck: never = shipmentType;
      throw new Error(exhaustiveCheck);
    }
  }
}

@Pipe({ name: 'tradeClass' })
export class TradeClassPipe implements PipeTransform {
  transform(tradeClass: TradeClass): unknown {
    return tradeClassToString(tradeClass);
  }
}
